import { useEffect, useRef } from 'react'

const useClickAwayListener = (callback: (event: MouseEvent) => void) => {
  const ref = useRef<any>(null)

  useEffect(() => {
    const handleClickAway = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event)
      }
    }

    document.addEventListener('click', handleClickAway)

    return () => {
      document.removeEventListener('click', handleClickAway)
    }
  }, [callback])

  return ref
}

export default useClickAwayListener
